import PlainLayout from "./Plain";

const Layouts = {
  PlainLayout,
};

export default Layouts;
